module.exports = __webpack_public_path__ + "img/pic.c82c0c9b.jpg";